const Share = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="share-07">
      <path
        id="Icon"
        d="M6.22667 9.00634L10.78 11.6597M10.7733 4.33967L6.22667 6.99301M14.5 3.33301C14.5 4.43758 13.6046 5.33301 12.5 5.33301C11.3954 5.33301 10.5 4.43758 10.5 3.33301C10.5 2.22844 11.3954 1.33301 12.5 1.33301C13.6046 1.33301 14.5 2.22844 14.5 3.33301ZM6.5 7.99967C6.5 9.10424 5.60457 9.99967 4.5 9.99967C3.39543 9.99967 2.5 9.10424 2.5 7.99967C2.5 6.89511 3.39543 5.99967 4.5 5.99967C5.60457 5.99967 6.5 6.89511 6.5 7.99967ZM14.5 12.6663C14.5 13.7709 13.6046 14.6663 12.5 14.6663C11.3954 14.6663 10.5 13.7709 10.5 12.6663C10.5 11.5618 11.3954 10.6663 12.5 10.6663C13.6046 10.6663 14.5 11.5618 14.5 12.6663Z"
        stroke="#535862"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Share;
